import * as React from "react";
const IconNotes = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.98633 6.99243H5.98633M12.9863 7.99243H18.9863M12.9863 11.9924H18.9863M12.9863 15.9924H15.9863M11.9863 20.9924H19.9863C21.6432 20.9924 22.9863 19.6493 22.9863 17.9924V5.99243C22.9863 4.33558 21.6432 2.99243 19.9863 2.99243H11.9863C10.3295 2.99243 8.98633 4.33558 8.98633 5.99243V17.9924C8.98633 19.6493 10.3295 20.9924 11.9863 20.9924ZM4.48633 20.9924L5.31453 19.7501C5.75258 19.0931 5.98633 18.321 5.98633 17.5313V4.49243C5.98633 3.664 5.31476 2.99243 4.48633 2.99243C3.6579 2.99243 2.98633 3.664 2.98633 4.49243V17.5313C2.98633 18.321 3.22008 19.0931 3.65813 19.7501L4.48633 20.9924Z"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconNotes;
